import { render, staticRenderFns } from "./ElephantFriend.vue?vue&type=template&id=61c50962&scoped=true"
import script from "./ElephantFriend.vue?vue&type=script&lang=js"
export * from "./ElephantFriend.vue?vue&type=script&lang=js"
import style0 from "./ElephantFriend.vue?vue&type=style&index=0&id=61c50962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c50962",
  null
  
)

export default component.exports